import React, { Fragment } from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import lifecycle from 'recompose/lifecycle'
import withHandlers from 'recompose/withHandlers'
import FullScreenSwipe from './FullScreenSwipe'
import scream from 'scream'
import brim from 'brim'
import { Helmet } from 'react-helmet'
import bugsnagClient from 'aria-viewer/core/bugsnagClient'

const styleSheet = {
    maskContainer: {
        '@media screen and (orientation: portrait)': {
            display: 'none !important',
        },
    },
}

const style = injectJss(styleSheet)

const withLifeCycle = lifecycle({
    componentDidMount() {
        // This needs to be done because HTML is set to fixed
        document.getElementsByTagName('html')[0].className = 'brim-absolute'
        try {
            this.brim = brim({
                viewport: this.props.scream,
            })

            this.brim && this.brim.on('viewchange', this.props.handleViewChange)
            this.props.scream.on('orientationchangeend', this.props.handleOrientationChanged)
        } catch (error) {
            bugsnagClient.notify(error)
        }
    },

    componentWillUnmount() {
        this.brim && this.brim.off('viewchange', this.props.handleViewChange)
        this.props.scream.off('orientationchangeend', this.props.handleOrientationChanged)
    },
})

const handlers = withHandlers({
    handleViewChange: ({ mainContainer, maskContainer, scream, onViewChange }) => event => {
        const orientation = scream.getOrientation()
        const isMinimalView = scream.isMinimalView()
        const viewPortWidth = scream.getViewportWidth()
        const viewPortHeight = scream.getViewportHeight()
        const screenWidth = scream.getScreenWidth()
        const screenHeight = scream.getScreenHeight()
        const notchPadding = scream.getNotchPadding()

        if (orientation == 'landscape') {
            if (event.viewName == 'minimal') {
                mainContainer.current.style.pointerEvents = 'all'
                maskContainer.current.style.pointerEvents = 'none'
            } else {
                mainContainer.current.style.pointerEvents = 'none'
                maskContainer.current.style.pointerEvents = 'all'
            }
        }

        onViewChange &&
            onViewChange(event, {
                orientation,
                isMinimalView,
                viewPortWidth,
                viewPortHeight,
                screenWidth,
                screenHeight,
                notchPadding,
            })
    },

    handleOrientationChanged: ({ mainContainer, maskContainer, scream, onOrientationChangeEnd }) => event => {
        const orientation = scream.getOrientation()
        const isMinimalView = scream.isMinimalView()
        const viewPortWidth = scream.getViewportWidth()
        const viewPortHeight = scream.getViewportHeight()
        const screenWidth = scream.getScreenWidth()
        const screenHeight = scream.getScreenHeight()
        const notchPadding = scream.getNotchPadding()

        if (!isMinimalView && orientation == 'landscape') {
            mainContainer.current.style.pointerEvents = 'none'
            maskContainer.current.style.pointerEvents = 'all'
        } else if (orientation == 'portrait') {
            mainContainer.current.style.pointerEvents = 'all'
            maskContainer.current.style.pointerEvents = 'none'
        }

        onOrientationChangeEnd &&
            onOrientationChangeEnd(event, {
                orientation,
                isMinimalView,
                viewPortWidth,
                viewPortHeight,
                screenWidth,
                screenHeight,
                notchPadding,
            })
    },
})

const withScream = WrappedComponent => props => {
    const Scream = scream({
        viewport: false,
        width: {
            portrait: screen.width,
            landscape: screen.height,
        },
    })

    return <WrappedComponent scream={Scream} {...props} />
}

const withRefs = WrappedComponent => props => (
    <WrappedComponent mainContainer={React.createRef()} maskContainer={React.createRef()} {...props} />
)

const LandscapeFullscreen = ({ children, classes, mainContainer, maskContainer }) => (
    <Fragment>
        <Helmet>
            <style>
                {`@media screen and (orientation: landscape) {
                        html.brim-absolute {
                            position: absolute;
                            background: #000;
                        }
                    }`}
            </style>
        </Helmet>
        <div id="brim-main" ref={mainContainer}>
            {children}
        </div>
        <div className={classes.maskContainer} id="brim-mask" ref={maskContainer}>
            <FullScreenSwipe />
        </div>
    </Fragment>
)

export default compose(
    style,
    withScream,
    withRefs,
    handlers,
    withLifeCycle,
    pure
)(LandscapeFullscreen)
